<template>
    <div class="contentLayout">
        <div class="contentNavigationBar">
            <h2 class="title">게시글 관리</h2>
        </div>
        <div class="contentBody">
            <h3 class="contentTitle">게시글 등록</h3>

            <!-- 입력 폼 -->
            <div class="infoWrap">
                <p class="requireText">(<em>*</em>) 항목은 필수 항목입니다.</p>
                <table class="infoTable marginBottom-35">
                    <tbody>
                        <tr>
                            <th class="requiredMark">회사명</th>
                            <td colspan="3">
                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.articleTitle"
                                    v-validate="'required'"
                                    data-vv-name="articleTitle"
                                    data-vv-as="회사명"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('articleTitle')"
                                >
                                    * {{ errors.first("articleTitle") }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <th class="requiredMark">분야</th>
                            <td>

                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.businessCategory"
                                    v-validate="'required'"
                                    data-vv-name="businessCategory"
                                    data-vv-as="분야"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('businessCategory')"
                                >
                                    * {{ errors.first("businessCategory") }}
                                </p>
                                
                            </td>
                            <th class="requiredMark">회원구분</th>
                            <td>
                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.companyLevel"
                                    v-validate="'required'"
                                    data-vv-name="companyLevel"
                                    data-vv-as="회원구분"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('companyLevel')"
                                >
                                    * {{ errors.first("companyLevel") }}
                                </p>
                            </td>
                        </tr>

                        <tr>
                            <th class="requiredMark">대표이사</th>
                            <td>
                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.companyCeoName"
                                    v-validate="'required'"
                                    data-vv-name="companyCeoName"
                                    data-vv-as="대표이사"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('companyCeoName')"
                                >
                                    * {{ errors.first("companyCeoName") }}
                                </p>
                            </td>
                            <th class="requiredMark">대표전화</th>
                            <td>
                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.companyTelNo"
                                    v-validate="'required'"
                                    data-vv-name="companyTelNo"
                                    data-vv-as="연락처"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('companyTelNo')"
                                >
                                    * {{ errors.first("companyTelNo") }}
                                </p>
                            </td>
                        </tr>

                        <tr>
                            <th class="requiredMark">이메일</th>
                            <td>
                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.managerEmailAddress"
                                    v-validate="'required'"
                                    data-vv-name="managerEmailAddress"
                                    data-vv-as="이메일"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('managerEmailAddress')"
                                >
                                    * {{ errors.first("managerEmailAddress") }}
                                </p>
                            </td>
                            <th class="requiredMark">홈페이지</th>
                            <td>
                                <input
                                    type="text"
                                    class="inputBox"
                                    v-model="articleInfo.companySiteAddress"
                                    v-validate="'required'"
                                    data-vv-name="companySiteAddress"
                                    data-vv-as="홈페이지"
                                />
                                <p
                                    class="validation-text"
                                    v-if="errors.has('companySiteAddress')"
                                >
                                    * {{ errors.first("companySiteAddress") }}
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <th class="requiredMark">내용</th>
                            <td colspan="3">
                                <p
                                    class="validation-text"
                                    v-if="errors.has('articleContents')"
                                >
                                    * {{ errors.first("articleContents") }}
                                </p>
                                <ckeditor
                                    v-validate="'required'"
                                    data-vv-name="articleContents"
                                    data-vv-as="내용"
                                    placeholder="내용을 입력해주세요."
                                    v-model="articleInfo.articleContents"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>첨부파일</th>
                            <td colspan="3">
                                <common-file
                                    ref="FileUploader"
                                    v-model="articleInfo.fileList"
                                    style="display: none"
                                />
                                <ul class="fileList">
                                    <li
                                        class="fileListItem marginBottom-10"
                                        v-for="(
                                            file, index
                                        ) in articleInfo.fileList"
                                        :key="file.serverFileSaveName"
                                    >
                                        <a
                                            href="#"
                                            class="fileDownLink marginRight-10"
                                            download
                                            >{{ file.fileName }}</a
                                        >
                                        <span class="fileSize marginRight-10">{{
                                            file.fileSizeName
                                        }}</span>
                                        <button
                                            class="squareBtn size-50"
                                            @click="deleteFile(index)"
                                        >
                                            삭제
                                        </button>
                                    </li>
                                </ul>

                                <div class="inputBtnWrap">
                                    <button
                                        class="squareBtn bgLightGray"
                                        type="button"
                                        @click="openUploader('FileUploader')"
                                    >
                                        파일선택
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- 하단 버튼 바 -->
            <div class="contentButtonBar">
                <div class="buttonWrap floatLeft">
                    <router-link
                        :to="{
                            path:
                                config.contextRoot +
                                '/site/' +
                                $route.params.siteNo +
                                '/article',
                            query: {
                                contentsNo: this.$route.query.contentsNo,
                            },
                        }"
                        class="radiusSmallBtn bgGray"
                    >
                        목록
                    </router-link>
                </div>
                <div class="buttonWrap floatRight">
                    <button
                        class="radiusSmallBtn bgNavy"
                        @click="insertArticle()"
                    >
                        저장
                    </button>
                    <button class="radiusSmallBtn bgDark" @click="reset()">
                        취소
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CommonFile from "@/components/common/CommonFile";
import ckeditor from "@/components/common/ckEditor.vue";
import EventBus from "../../script/EventBus";
export default {
    name: "ArticleCompanyCreate",
    data() {
        return {
            siteNo: "",
            boardList: [],
            item: {},
            editor: "",
            articleInfo: {
                contentsNo: "",
                articleTitle: "",
                articleContents: "",
                articleNoticeYn: "N",
                boardCommentUseYn: "N",
                fileGroupNo: "",
                fileList: [],
                businessCategory: ""
            },
            isShowNoticeUseYn: false,
        };
    },
    created() {
        this.siteNo = this.$route.params.siteNo;
        this.selectBoardList();
        EventBus.$on("addFile", (fileList) => {
            this.logger.debug(this, "eventBus / addFile()");
            this.addFile(fileList);
        });
    },
    components: {
        CommonFile,
        ckeditor,
    },
    methods: {
        selectBoardList() {
            this.logger.debug(this, "selectBoardList()");
            var searchData = {};
            axios
                .post(
                    this.config.contextRoot + "/article/selectBoardList.do",
                    searchData
                )
                .then((response) => {
                    this.boardList = response.data.boardList;
                    if (this.boardList.length > 0) {
                        if (this.$route.query.contentsNo) {
                            this.articleInfo.contentsNo =
                                this.$route.query.contentsNo;
                        } else {
                            this.articleInfo.contentsNo =
                                this.boardList[0].contentsNo;
                        }
                        this.onContentsNoChange();
                    }
                })
                .catch((error) => {
                    this.exceptionHandler(this, error);
                });
        },
        insertArticle() {
            this.logger.debug(this, "insertArticle()");

            if (!confirm("등록 하시겠습니까?")) {
                return;
            }
            this.$validator
                .validateAll()
                .then((result) => {
                    this.logger.debug(this, "valid:" + result);
                    if (!result) {
                        alert(
                            "정보가 제대로 입력되지 않았습니다.\n다시 한번 확인해주세요."
                        );
                        return;
                    }

                    axios
                        .post(
                            this.config.contextRoot +
                                "/article/insertArticle.do",
                            this.articleInfo
                        )
                        .then((response) => {
                            if (response.data.articleNo) {
                                alert("등록 되었습니다.");
                                this.$router.replace(
                                    this.config.contextRoot +
                                        "/site/" +
                                        this.siteNo +
                                        "/article/" +
                                        response.data.articleNo +
                                        "/edit?contentsNo=10"
                                );
                            }
                        })
                        .catch((error) => {
                            this.exceptionHandler(this, error);
                        });
                })
                .catch(() => {
                    this.logger.debug(this, "-->" + this.error.all());
                    this.$alert(this.error.all());
                    return false;
                });
        },

        reset() {
            if (confirm("취소 하시겠습니까?")) {
                this.$router.go(this.$router.currentRoute);
            }
        },
        openUploader(refName) {
            this.logger.debug(this, "openUploader()");
            this.$refs[refName].openUploader();
        },
        doDownload(data) {
            this.logger.debug(this, "doDownload");
            const formData = new FormData();
            formData.append("fileNo", data.fileNo);
            formData.append("fileName", data.fileName);
            formData.append("serverFileSaveName", data.serverFileSaveName);
            axios
                .post(
                    this.config.contextRoot + "/common/file/download.do",
                    formData,
                    { responseType: "blob" }
                )
                .then((response) => {
                    console.log(response);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data], {
                            type: response.headers["content-type"],
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", data.fileName);
                    document.body.appendChild(link);
                    link.click();
                    location.reload();
                })
                .catch((error) => {
                    this.exceptionHandler(this, error);
                });
        },
        deleteFile(index) {
            this.articleInfo.fileList.splice(index, 1);
        },
        addFile(fileList) {
            this.articleInfo.fileList =
                this.articleInfo.fileList.concat(fileList);
        },
    },
};
</script>

<style>
</style>